import { BasePageComponent } from '@/components/base/BasePageComponent';
import { ShareRequestTableComponent } from '@/components/share-request-table/share-request-table.component';
import { ShareTableComponent } from '@/components/share-table/share-table.component';
import { ActionDoneType } from '@/enums/ActionDoneType.enum';
import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { UserHelper } from '@/helpers/user.helper';
import { AppConfigService } from '@/services/app-config.service';
import { AuthenticationService } from '@/services/authentication.service';
import { NavService } from '@/services/nav.service';
import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {
  PropertiesService,
  RealProperty,
  Sharing,
  SharingRequest,
  SharingService,
  UserSession
} from '@eemo/api-client';
import { Subscription, forkJoin } from 'rxjs';
import { DataLoadingComponent } from '../../components/data-loading/data-loading.component';
import { PageTitleComponent } from '../../components/page-title/page-title.component';
import { ShareTableComponent as ShareTableComponent_1 } from '../../components/share-table/share-table.component';

@Component({
  selector: 'app-shares',
  templateUrl: './shares.component.html',
  styleUrls: ['./shares.component.scss'],
  standalone: true,
  imports: [NgIf, DataLoadingComponent, PageTitleComponent, ShareTableComponent_1, ShareRequestTableComponent]
})
export class SharesComponent extends BasePageComponent implements OnInit, OnDestroy {
  @ViewChildren(ShareTableComponent) dataComponents: QueryList<ShareTableComponent>;

  subs: Subscription[] = [];

  currentUser: UserSession;
  myRequests: SharingRequest[] = [];
  myShares: Sharing[] = [];
  myAccesses: Sharing[] = [];
  myRealProperties: RealProperty[] = [];
  prop: RealProperty;
  loading = true;

  mySharesDescription = '';
  myAccessesDescription = 'Aucun accès';

  constructor(
    private authenticationService: AuthenticationService,
    private sharingService: SharingService,
    private propertyService: PropertiesService,
    private userHelper: UserHelper,
    private dialog: MatDialog,
    protected route: ActivatedRoute,
    protected navService: NavService,
    private appConfigService: AppConfigService
  ) {
    super(route, navService);
    this.authenticationService.currentUser.subscribe((value) => {
      if (value) {
        this.currentUser = value;
      }
    });
    this.subs.push(
      this.appConfigService.actionDone.subscribe((a) => {
        if (ActionDoneType.SHARE === a) {
          this.loadData();
        }
      })
    );
    this.subs.push(
      this.appConfigService.objectUpdated.subscribe((o) => {
        if (ObjectUpdatedType.SHARE === o) {
          this.loadData();
        }
      })
    );
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  loadData() {
    this.myRequests = [];
    this.subs.push(this.sharingService.getSharingRequestList().subscribe((requests) => (this.myRequests = requests)));

    this.myRealProperties = [];
    this.myShares = [];
    this.myAccesses = [];
    // TODO manage pagination
    this.subs.push(
      forkJoin([
        this.propertyService.getRealPropertyList(),
        this.sharingService.getUserSharingList(this.currentUser.userId)
      ]).subscribe({
        next: ([propertyShareData, userShareData]) => {
          propertyShareData.list.forEach((prop) => {
            if (this.userHelper.canUpdateProperty(prop)) {
              this.myRealProperties.push(prop);
              this.sharingService.getRealPropertySharingList(prop.uid).subscribe((shareList) => {
                this.myShares.push(...shareList);
                this.dataComponents.forEach((comp) => comp.loadData());

                this.mySharesDescription =
                  this.myShares.length > 1
                    ? this.myShares.length + ' partages'
                    : this.myShares.length == 1
                    ? '1 partage'
                    : 'Aucun partage';
              });
            }
          });
          this.myAccesses.push(...userShareData);
          this.dataComponents.forEach((comp) => comp.loadData());
          this.myAccessesDescription =
            this.myAccesses.length > 1
              ? this.myAccesses.length + ' accès'
              : this.myAccesses.length == 1
              ? '1 accès'
              : 'Aucun accès';
        },
        complete: () => setTimeout(() => (this.loading = false))
      })
    );
  }
}
